import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-dropdown-select';
import services from '../../services';
import './User.css';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';
import DeletePopup from '../DeletePopup';
import { FormControlLabel, Switch } from '@mui/material';
import { FiChevronLeft, FiLayout, FiPlus, FiSave, FiTrash2, FiEdit2, FiUser } from 'react-icons/fi';
import { styles } from './UserAssignBoard.styles';

const UserAssignBoard = () => {
    const { state } = useLocation();
    const [allPermission, setAllPermission] = useState([]);
    const [boardColumn, setBoardColumn] = useState([]);
    const [selectedPerIds, setSelectedPerIds] = useState([]);
    const [selectedColumnIds, setSelectedColumnIds] = useState([]);
    const [selectedBoards, setSelectedBoards] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const navigate = useNavigate();
    const [allASSIGNMENT, setAllASSIGNMENT] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [columnError, setColumnError] = useState(false);
    const [isManager, setIsManager] = useState(false);

    const handleToggle = (event) => {
        setIsManager(event.target.checked);
    };

    const handleManagerToggle = (index, checked) => {
        const updatedAssignments = [...allASSIGNMENT];
        updatedAssignments[index] = {
            ...updatedAssignments[index],
            isManager: checked,
        };
        setAllASSIGNMENT(updatedAssignments);
    };

    const handleSelect = (selected) => {
        setSelectedBoards(selected);
        if (selected && selected.length > 0) {
            getBoardColumn(selected[0].value);
        } else {
            setBoardColumn([]);
        }
    };

    const assignedBoardIds = allASSIGNMENT?.map((a) => a.Board?.value);
    const availableBoards = boardName.filter((b) => !assignedBoardIds.includes(b.value));

    const getAvailableBoardsForEdit = (currentIndex) => {
        const otherAssignedBoardIds = allASSIGNMENT
            .filter((_, i) => i !== currentIndex)
            .map((a) => a.Board?.value);
        return boardName.filter((b) => !otherAssignedBoardIds.includes(b.value));
    };

    const handleEditBoard = async (id, item) => {
        const data = {
            boardId: item.Board?.value,
            userId: state.id,
            boardListId: item.boardListId?.map((col) => col),
            permissions: item.permissions?.map((per) => per),
            isManager:item?.isManager
        };
        try {
            const response = await services.userassignboard.UPDATE_UserAssignBoard(id, data);
            if (response.status === 200) {
                toast.success('Assignment updated successfully');
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
            toast.error('Failed to update assignment');
        }
    };

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const filterData =
                (data && data.length > 0 && data.map(({ boardName, id }) => ({ label: boardName, value: id }))) || [];

            setBoardName(filterData);
            GET_ALL_ASSIGNMENT(filterData);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getAllBoard();
        GET_ALL_PERMISSION();
    }, []);

    const GET_ALL_PERMISSION = async () => {
        try {
            const response = await services.permission.GET_ALL_PERMISSION();
            const data =
                (response &&
                    response.length > 0 &&
                    response.map((item) => ({
                        ...item,
                        label: item.name,
                        permission_details: item.details,
                        value: item.id,
                    }))) ||
                [];
            setAllPermission(data);
        } catch (e) {
            console.error(e);
        }
    };

    const getBoardColumn = async (id) => {
        try {
            const response = await services.board.SELECTED_BOARD(id);
            const data = response?.data
                ?.slice()
                .sort((a, b) => Number(a.sequence) - Number(b.sequence))
                .map((item) => ({
                    value: item?.id,
                    label: item?.coloum,
                }));
            setBoardColumn(data);
        } catch (e) {
            console.error(e);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (selectedBoards.length > 0 && assignedBoardIds.includes(selectedBoards[0]?.value)) {
            toast.error('This board is already assigned to this user');
            return;
        }
        if (!selectedColumnIds || selectedColumnIds?.length === 0) {
            setColumnError(true);
            return;
        }
        const data = {
            boardId: selectedBoards[0]?.value,
            userId: state.id,
            boardListId: selectedColumnIds.map((item) => item),
            permissions: selectedPerIds.map((item) => item),
            isManager:isManager
        };
        try {
            const response = await services.userassignboard.CREATE_UserAssignBoard(data);
            if (response.status === 201) {
                toast.success('Board assigned successfully');
                setSelectedBoards([]);
                setSelectedColumnIds([]);
                setSelectedPerIds([]);
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const GET_ALL_ASSIGNMENT = async (filterData) => {
        try {
            const response = await services.userassignboard.GET_UserAssignBoard_ID(state.id);

            const dataMap = response?.data?.data?.map((item, index) => ({
                ...item,
                boardListId: typeof item?.boardListId === 'string' ? JSON.parse(item?.boardListId) : item?.boardListId,
                permissions: typeof item?.permissions === 'string' ? JSON.parse(item?.permissions) : item?.permissions,
                BoardLists: Array.isArray(item?.Board?.BoardLists)
                    ? item.Board.BoardLists
                        .slice()
                        .sort((a, b) => Number(a.sequence) - Number(b.sequence))
                        .map((listItem) => ({
                            label: listItem?.coloum,
                            value: listItem?.id,
                        }))
                    : [],
                Board: item?.Board
                    ? {
                        label: item.Board.boardName,
                        value: item.Board.id,
                    }
                    : { label: '', value: '' },
            }));
            setAllASSIGNMENT(dataMap || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleEditCol = (index, selectedOptions) => {
        const allOptions = allASSIGNMENT[index]?.BoardLists || [];
        let updatedSelectedOptions = selectedOptions;

        if (selectedOptions.length === allOptions.length) {
            if (!selectedOptions.some(opt => opt.value === "*")) {
                updatedSelectedOptions = [...selectedOptions, { label: "*", value: "*" }];
            }
        } else {
            updatedSelectedOptions = selectedOptions.filter(opt => opt.value !== "*");
        }
        const updatedAssignments = [...allASSIGNMENT];
        updatedAssignments[index] = {
            ...updatedAssignments[index],
            boardListId: updatedSelectedOptions,
        };
        setAllASSIGNMENT(updatedAssignments);
    };

    const handleDelete = async (id) => {
        setDeleteId(id);
        setShowDeletePopup(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await services.userassignboard.DELETE_UserAssignBoard(deleteId);
            if (response.status === 200) {
                toast.success('Assignment deleted successfully');
                getAllBoard();
            }
        } catch (e) {
            toast.error('Failed to delete assignment');
            console.error(e);
        } finally {
            setShowDeletePopup(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setShowDeletePopup(false);
        setDeleteId(null);
    };

    const handleEditSelect = async (selected, index) => {
        if (!selected || selected.length === 0) return;
        const selectedBoard = selected[0];
        try {
            const response = await services.board.SELECTED_BOARD(selectedBoard.value);
            const columns = response?.data
                ?.slice()
                .sort((a, b) => Number(a.sequence) - Number(b.sequence))
                .map((item) => ({
                    value: item?.id,
                    label: item?.coloum,
                }));

            const updatedAssignments = [...allASSIGNMENT];
            updatedAssignments[index] = {
                ...updatedAssignments[index],
                Board: selectedBoard,
                BoardLists: columns,
                boardListId: [],
            };
            setAllASSIGNMENT(updatedAssignments);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div style={styles.pageWrapper} className="assign-board-page-scroll">

            {/* ── Page Header ── */}
            <div style={styles.pageHeader}>
                <button
                    style={styles.btnBack}
                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                    onClick={() => navigate(-1)}
                >
                    <FiChevronLeft size={15} />
                    Back
                </button>

                <div style={styles.headerCenter}>
                    <div style={styles.pageTitleIcon}>
                        <FiLayout size={18} color="#fff" />
                    </div>
                    <div style={styles.pageTitleBlock}>
                        <h5 style={styles.pageTitle}>Assign Boards and Columns</h5>
                        <span style={styles.pageSubtitle}>Manage board access and column permissions</span>
                    </div>
                </div>

                {state?.name && (
                    <div style={styles.userPill}>
                        <FiUser size={12} />
                        {state.name}
                    </div>
                )}
            </div>

            {/* ── New Assignment ── */}
            <div style={styles.sectionHeading}>
                <div style={styles.sectionBar} />
                <span style={styles.sectionTitle}>New Assignment</span>
                <span style={styles.sectionBadge}>
                    <FiPlus size={10} />
                    Add
                </span>
            </div>

            <div style={styles.assignCardNew}>
                <div style={styles.formRow}>
                    {/* Board */}
                    <div style={styles.formItem}>
                        <label style={styles.fieldLabel}>Board</label>
                        <Select
                            options={availableBoards}
                            onChange={handleSelect}
                            values={selectedBoards}
                            portal={document.body}
                            dropdownPosition="auto"
                            dropdownHeight="200px"
                            dropdownGap={6}
                            contentRenderer={({ props, state }) => (
                                <div
                                    className="assign-board"
                                    title={state.values.map((val) => val.label).join(', ')}
                                >
                                    {state.values.map((val) => val.label).join(', ')}
                                </div>
                            )}
                        />
                    </div>

                    {/* Column */}
                    <div style={styles.formItem}>
                        <label style={styles.fieldLabel}>Column</label>
                        <div className="drop-header">
                            <MultiSelect
                                options={boardColumn}
                                value={selectedColumnIds}
                                onChange={(selectedOptions) => {
                                    setSelectedColumnIds(selectedOptions);
                                    if (selectedOptions.length > 0) setColumnError(false);
                                }}
                                labelledBy="Select Column"
                            />
                        </div>
                        {columnError && (
                            <span style={styles.errorText}>Please select at least one column.</span>
                        )}
                    </div>

                    {/* Manager toggle */}
                    <div style={styles.managerBlock}>
                        <span style={styles.managerLabel}>Manager</span>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isManager}
                                    onChange={handleToggle}
                                    name="managerSwitch"
                                    color="primary"
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#1a7d3e' },
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1a7d3e' },
                                    }}
                                />
                            }
                            label=""
                            style={{ margin: 0 }}
                        />
                    </div>

                    {/* Save */}
                    <div style={styles.actionBlock}>
                        <button
                            style={styles.btnSave}
                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                            onClick={handleSubmit}
                        >
                            <FiSave size={13} />
                            Save
                        </button>
                    </div>
                </div>
            </div>

            {/* ── Existing Assignments ── */}
            {allASSIGNMENT?.length > 0 && (
                <div style={{ ...styles.sectionHeading, marginTop: '6px' }}>
                    <div style={styles.sectionBar} />
                    <span style={styles.sectionTitle}>Existing Assignments</span>
                    <span style={styles.sectionBadge}>{allASSIGNMENT.length}</span>
                </div>
            )}

            {allASSIGNMENT?.map((item, index) => {
                const selectedOptions = item?.boardListId || [];
                const allOptions = item?.BoardLists || [];
                const valueToPass = selectedOptions.some(opt => opt.value === '*')
                    ? [...allOptions]
                    : selectedOptions;

                return (
                    <div
                        key={index}
                        style={styles.assignCard}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#bbf7d0'; e.currentTarget.style.boxShadow = '0 3px 12px rgba(26,125,62,0.1)'; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.05)'; }}
                    >
                        <div style={styles.cardIndexChip}>{index + 1}</div>

                        <div style={styles.formRow}>
                            {/* Board */}
                            <div style={styles.formItem}>
                                <label style={styles.fieldLabel}>Board</label>
                                <Select
                                    options={getAvailableBoardsForEdit(index)}
                                    onChange={(selected) => handleEditSelect(selected, index)}
                                    values={[item?.Board]}
                                            portal={document.body}
                                    dropdownPosition="auto"
                                    dropdownHeight="200px"
                                    dropdownGap={6}
                                    contentRenderer={({ props, state }) => (
                                        <div
                                            className="assign-board"
                                            title={state.values.map((val) => val.label).join(', ')}
                                        >
                                            {state.values.map((val) => val.label).join(', ')}
                                        </div>
                                    )}
                                />
                            </div>

                            {/* Column */}
                            <div style={styles.formItem}>
                                <label style={styles.fieldLabel}>Column</label>
                                <div className="drop-header">
                                    <MultiSelect
                                        options={item?.BoardLists}
                                        value={valueToPass}
                                        onChange={(selectedOptions) => handleEditCol(index, selectedOptions)}
                                        labelledBy="Select Column"
                                    />
                                </div>
                            </div>

                            {/* Manager toggle */}
                            <div style={styles.managerBlock}>
                                <span style={styles.managerLabel}>Manager</span>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={Boolean(item?.isManager)}
                                            name="managerSwitch"
                                            color="primary"
                                            onChange={(e) => handleManagerToggle(index, e.target.checked)}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#1a7d3e' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1a7d3e' },
                                            }}
                                        />
                                    }
                                    label=""
                                    style={{ margin: 0 }}
                                />
                            </div>

                            {/* Update + Delete */}
                            <div style={styles.actionBlock}>
                                <button
                                    style={styles.btnUpdate}
                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                                    onClick={() => handleEditBoard(item.id, item)}
                                >
                                    <FiEdit2 size={12} />
                                    Update
                                </button>
                                <button
                                    style={styles.btnDelete}
                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fee2e2'; e.currentTarget.style.borderColor = '#fca5a5'; }}
                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff5f5'; e.currentTarget.style.borderColor = '#fee2e2'; }}
                                    onClick={() => handleDelete(item.id)}
                                >
                                    <FiTrash2 size={12} />
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}

            {allASSIGNMENT?.length === 0 && (
                <div style={styles.emptyState}>
                    <FiLayout size={38} color="#d1d5db" />
                    <p style={styles.emptyText}>No board assignments yet — add one above</p>
                </div>
            )}

            {showDeletePopup && (
                <DeletePopup
                    open={showDeletePopup}
                    title="Are you sure you want to delete this assignment?"
                    onConfirm={confirmDelete}
                    onCancel={cancelDelete}
                    confirmLabel="YES, I'M SURE"
                    cancelLabel="NO"
                />
            )}
        </div>
    );
};

export default UserAssignBoard;
